// @flow
export default {
  accountButton: {
    textDecoration: 'none',
    color: 'black'
  },
  white: {
    color: 'white'
  },
  red: {
    color: 'red'
  },
  black: {
    color: 'black'
  }
}
